module.exports = __webpack_public_path__ + "static/media/play-button.ede9c047.svg";